import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private http = inject(HttpClient);

  get<T>(path: string, options?: { params?: HttpParams }): Observable<T> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true,
      ...options // Spread the optional options (e.g., query parameters) into the request
    };
    return this.http.get<T>(path, httpOptions) as Observable<T>;
  }

  getBlob<Blob>(path: string): Observable<Blob> {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true,
      responseType: 'blob' as 'json'
    }
    return this.http.get(path, options) as Observable<Blob>;
  }

  put<T>(path: string, body: object = {}): Observable<T> {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true
    }
    return this.http.put(path, JSON.stringify(body), options) as Observable<T>;
  }

  post<T>(path: string, body: object = {}): Observable<T> {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true
    }
    return this.http.post(path, JSON.stringify(body), options) as Observable<T>;
  }

  postForm<T>(path: string, body: object = {}): Observable<T> {
    const options = {
      withCredentials: true
    }
    return this.http.post(path, body, options) as Observable<T>;
  }

  postReturnText<T>(path: string, body: object = {}): Observable<T> {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true,
      responseType: 'text' as const
    }
    return this.http.post(path, JSON.stringify(body), options) as Observable<T>;
  }

  delete<T>(path: string): Observable<T> {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true
    }
    return this.http.delete(path, options) as Observable<T>;
  }

  postWithQuery<T>(path: string, body: object = {}, queryParams?: { [key: string]: string | string[] | undefined }): Observable<T> {
    let params = new HttpParams();

    // Add query parameters if provided
    if (queryParams) {
      Object.keys(queryParams).forEach(key => {
        const value = queryParams[key];
        if (value !== undefined && value !== null) {
          if (Array.isArray(value)) {
            value.forEach(v => params = params.append(key, v));
          } else {
            params = params.set(key, value);
          }
        }
      });
    }

    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true,
      params: params
    };

    return this.http.post(path, JSON.stringify(body), options) as Observable<T>;
  }
}
